<template>
  <div>
    <!-- FOOTER -->
    <footer>
      <div class="container py-3">
        <div class="row mb-3">

          <div class="col-md-12 col-lg-4 mb-4 mb-md-3">
            <p class="fw-500 typography-headline-sm text-primary mb-3">Colorffy</p>
            <div>
              <input type="checkbox" class="btn-check" id="btn-check" autocomplete="off" v-model="darkMode">
              <label class="btn btn-default-outline btn-micint-rotate btn-round ripple ripple-primary m-0"
                     for="btn-check">
                <i class="material-icons-outlined me-2" :class="[ darkMode ? 'text-warning' : 'text-muted']">
                  {{ darkMode ? '&#xe3aa;' : '&#xe51c;' }}</i>
                Turn {{ darkMode ? 'on' : 'off' }} the lights
              </label>
            </div>
          </div>
          <!-- PROJECTS -->
          <div class="col-6 col-md-4 col-lg-3 mb-3 mb-md-0">
            <p class="fw-500 typography-headline-sm mb-3">Projects</p>
            <div class="mb-3">
              <a href="https://the-docs.com/?ref=colorffy" title="TheDocs" rel="noopener" target="_blank"
                 class="subtitle-1 text-underline">
                The Docs
                <div class="badge badge-success">Available now</div>
              </a>
            </div>
            <div class="mb-3">
              <a href="https://menuffy.com/?ref=colorffy" title="Menuffy" rel="noopener" target="_blank"
                 class="subtitle-1 text-underline">
                Menuffy
              </a>
            </div>
          </div>
          <!-- ABOUT US -->
          <div class="col-6 col-md-4 col-lg-3 mb-3 mb-md-0">
            <p class="fw-500 typography-headline-sm mb-3">About Us</p>

            <div class="mb-3">
              <router-link to="/whats-new" title="What's new?" class="subtitle-1 text-underline">
                What's new?
                <!--                <div class="badge badge-success">NEW UPDATE</div>-->
              </router-link>
            </div>
            <div class="mb-3">
              <router-link to="/team" title="Team" class="subtitle-1 text-underline">
                Team
              </router-link>
            </div>
            <div class="mb-3">
              <router-link to="/privacy" title="Privacy Policy" class="subtitle-1 text-underline">
                Privacy Policy
              </router-link>
            </div>
            <div class="mb-3">
              <router-link to="/terms" title="Terms of service" class="subtitle-1 text-underline">
                Terms of service
              </router-link>
            </div>
            <div class="mb-3">
              <router-link to="/cookies" title="Cookies Policy" class="subtitle-1 text-underline">
                Cookies Policy
              </router-link>
            </div>
          </div>
          <!-- HELP -->
          <div class="col-md-4 col-lg-2 mb-3 mb-md-0">
            <p class="fw-500 typography-headline-sm mb-3">Help</p>
            <div class="mb-3">
              <a href="https://colorffy.the-docs.com/docs/latest/support/help-guide" title="User Guides"
                 class="subtitle-1 text-underline" target="_blank" rel="noopener">
                Guides
              </a>
            </div>
            <div class="mb-3">
              <a href="mailto:colorffy@gmail.com" title="Contact Us" class="subtitle-1 text-underline">
                Support
              </a>
            </div>
            <hr>
            <!-- SOCIAL MEDIA -->
            <div class="mb-3">
              <a href="https://twitter.com/colorffy" title="Twitter" target="_blank" rel="noopener"
                 class="subtitle-1 text-underline">
                <img class="img-fluid me-1" width="24px" height="24px"
                     src="@/assets/img/icons/twitter-fill.svg"
                     alt="Twitter"> Twitter
              </a>
            </div>
            <div class="mb-3">
              <a href="https://www.instagram.com/colorffyweb/" title="Instagram" target="_blank" rel="noopener"
                 class="subtitle-1 text-underline">
                <img class="img-fluid  me-1" width="24px" height="24px"
                     src="@/assets/img/icons/instagram-line.svg"
                     alt="Twitter"> Instagram
              </a>
            </div>
          </div>

        </div>

        <div class="row mb-3">
          <!-- PRODUCT HUNT BADGE -->
          <div class="col-md-12">
            <!-- BUY ME A COFFEE BADGE -->
            <a href="https://www.buymeacoffee.com/giancarlosgza" target="_blank" rel="noopener">
              <img class="border-radius-0" width="180px" height="54px" alt="Buy me a Coffee - Giancarlos Gza"
                   src="https://img.buymeacoffee.com/button-api/?text=Buy me a coffee&emoji=&slug=giancarlosgza&button_colour=3b2eff&font_colour=ffffff&font_family=Poppins&outline_colour=ffffff&coffee_colour=FFDD00"></a>
          </div>
        </div>

        <hr class="my-4">

        <div class="row">
          <div class="col-8 col-md-6 text-start align-self-center mb-3">
            <p class="subtitle-1 pb-0 mb-0">Made with ❤️ & ☕ by
              <a href="https://giangza.dev/?ref=colorffy" title="GianGza website"
                 target="_blank" rel="noopener"
                 class="subtitle-1 text-underline">@giangzadev</a> &
              <a href="https://www.youtube.com/c/serveix/featured" title="Eli Lopez YouTube" target="_blank"
                 rel="noopener"
                 class="text-underline">@elilopezdev</a>
            </p>

            <div class="float-made-by">
              <small>By: </small>
              <a href="https://www.youtube.com/c/serveix/featured" target="_blank" rel="noopener">
                <img src="@/assets/img/logos/eli-normal.jpeg" width="20px"
                     height="20px"
                     alt="Eli photo" class="img-fluid border-radius-50"> @carloselilopez</a>
              <small> &amp; </small>
              <a href="https://giangza.dev/?ref=colorffy" target="_blank" rel="noopener">
                <img src="@/assets/img/logos/gian-indigo.png" width="20px"
                     height="20px"
                     alt="Gian photo" class="img-fluid border-radius-50"> @giangzadev</a>
            </div>

          </div>
          <div class="col-4 col-md-6 text-end align-self-center">
            <p class="subtitle-2">
              ©2021 Colorffy v4
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="float-ads" :class="{'d-none' : closeAd}">
              <div class="float-ads close">
                <i class="material-icons-outlined" @click="closeAdFunction">close</i>
              </div>
              <VueScriptComponent
                  script='<script async type="text/javascript" src="//cdn.carbonads.com/carbon.js?serve=CEBI6K7Y&placement=wwwcolorffycom" id="_carbonads_js"></script>'/>
            </div>

            <div class="cookies-banner" :class="[ cookiesToggle ? 'd-none' : 'd-block']">
              <div class="cookies-banner-content">
                <img src="@/assets/img/onboardings/cookies.svg" class="img-fluid mb-2" width="100px" height="100px"
                     alt="Cookies icon">
                <div class="cookies-title">🍪 Cookies!</div>
                <div class="cookies-subtitle">We use cookies to make your experience better.</div>
                <div class="cookies-footer">
                  <router-link to="/cookies" class="btn btn-default-outline ripple ripple-primary">Cookies policy
                  </router-link>

                  <input type="checkbox" class="btn-check" id="btn-check-cookies" autocomplete="off"
                         v-model="cookiesToggle">
                  <label class="btn btn-primary ripple"
                         for="btn-check-cookies">
                    Got it
                  </label>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </footer>
  </div>
</template>

<script>
import VueScriptComponent from 'vue-script-component'

export default {
  data() {
    return {
      closeAd: false
    }
  },
  components: {
    VueScriptComponent
  },
  computed: {
    darkMode: {
      get() {
        return this.$store.getters.darkMode
      },
      set(newValue) {
        this.$store.commit("SET_DARK_MODE", newValue)
      }
    },
    cookiesToggle: {
      get() {
        return this.$store.getters.cookiesToggle
      },
      set(cookiesValue) {
        this.$store.commit("SET_COOKIES_ACCEPTED", cookiesValue)
      }
    }
  },
  methods: {
    closeAdFunction() {
      this.closeAd = true
    }
  }
}
</script>
